import { Maximize2, Minimize2 } from "lucide-react";
import { motion } from "framer-motion";
import { useFullscreen } from "@/hooks/useFullscreen";
import { useDevice } from "@/hooks/useDevice";

export const FullscreenButton = () => {
  const { isFullscreen, toggle, supported } = useFullscreen();
  const { type } = useDevice();

  if (!supported) return null;

  const Icon = isFullscreen ? Minimize2 : Maximize2;
  const label = isFullscreen ? "Keluar Fullscreen" : "Fullscreen";

  return (
    <motion.button
      data-testid="fullscreen-toggle-btn"
      onClick={toggle}
      title={`${label} (${type})`}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      className="fixed top-3 right-16 sm:right-20 z-50 glass-card-strong rounded-full p-2.5 sm:p-3 border-2 border-gold/40 hover:border-gold/80 text-gold shadow-lg hover:shadow-gold/30 transition-all"
      aria-label={label}
    >
      <Icon className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={2.5} />
    </motion.button>
  );
};

export default FullscreenButton;
